// Deps
import { useState, useEffect } from 'react'
import { setError } from 'controllers/navigator'

// Services
import sysServices from 'services/sys'

const useDistricts = (city) => {
	const [districts, setDistricts] = useState(false);
	const [fetchedCity, setFetchedCity] = useState(false);

	useEffect(() => {
		if(city && city.id !== 0) {
			if(!fetchedCity || (fetchedCity && fetchedCity.id !== city.id)) {
				sysServices.getDistricts(city.id).then((payload) => {
					setFetchedCity(city);
					setDistricts(payload);
				}).catch(() => {
					setError();
				})
			}
		}
		else if(districts && (!city || (city && city.id === 0))) {
			setFetchedCity(false);
			setDistricts(false);
		}
	}, [districts, city, fetchedCity])

	return districts;
}

export default useDistricts;